/* Mykonos EU — live activity popup ("salespop"). Real purchases, real cart-adds,
   real 5-star Judge.me PRODUCT reviews and real 5-star SHOP reviews from
   mk-salespop.fragrance-gems.workers.dev; nothing here invents an entry. Deferred,
   work starts after load/first interaction, fixed overlay so no CLS.

   Second instance of the FragranceGems popup (see Documents/coding menu/
   fragrancegems-salespop and areas/fg-salespop.md for the measurements behind the
   choices repeated here). Separate Worker, separate D1, separate theme asset —
   nothing is shared between the two shops.

   This file is the SOURCE and is edited here directly — Shopify minifies theme JS on
   its own CDN (it renames variables, strips comments and emits its own .js.map whose
   sourcesContent is this file), so the comments cost the visitor nothing. Served size
   must stay under 5 KB gzipped. DO NOT pre-minify. */
(function () {
  'use strict';

  var API = 'https://mk-salespop.fragrance-gems.workers.dev';

  /* Cadence is per viewport, not one number. On desktop the toast sits in an empty
     bottom-left corner and costs the shopper nothing, so it can come round often. On
     a phone it covers real estate directly above the sticky add-to-cart bar, so it
     stays noticeably rarer. Same 749px breakpoint the theme uses. Read live rather
     than cached, so a rotation or resize is respected. */
  var PHONE = matchMedia('(max-width: 749px)');
  var GAP = { phone: [25000, 60000], desktop: [7000, 14000] };
  /* The FIRST card comes sooner than the rest: the opening beat is the one most
     visitors are still around for. Nothing to do with load speed, just the timer. */
  var FIRST_GAP = { phone: [8000, 15000], desktop: [3000, 7000] };
  var VISIBLE_MS = 5000; // auto-dismiss
  var RECHECK_MS = 2000; // how often to retry while another popup holds the screen
  /* Nobody should see the same perfume announced over and over. The server already
     avoids two in a row; this caps how often one product may come back to THIS
     visitor before the feed has to offer something else. */
  var MAX_PER_PRODUCT = 2;
  var HIDE_KEY = 'mk_sp_off';     // visitor opted out (localStorage, no expiry)
  var SEEN_KEY = 'mk_sp_seen';    // product -> times shown this tab session
  var ATTR_KEY = 'mk_sp_attr';    // the first card of the session, then 1 once written
  /* 0 = always visible. Started at 2 on the reasoning that advertising the exit
     costs impressions. The owner went looking for it twice on the FragranceGems
     store and could not find it, which settles it for both: an opt-out nobody
     can find is not really an opt-out. */
  var HIDE_AFTER_DISMISSALS = 0;

  /* Quick view, review lightbox and store panel live in their own asset, fetched
     only when a shopper actually clicks a toast, so they never touch the page-load
     budget.

     The URL comes from Liquid (data-qv in theme.liquid), not from a counter kept
     here. Shopify's CDN caches per EXACT URL including the query string, so a
     hand-maintained ?v= has to be bumped on every change -- and on the
     FragranceGems store that bit us on 20 sep 2026: ?v=5 was requested during
     TESTING before the new file had been uploaded, so the CDN pinned the OLD
     body to the NEW number and kept serving it. `asset_url` emits Shopify's own
     content hash for the current file, so it is always right. */
  var QV_SRC = (document.currentScript && document.currentScript.dataset.qv) || '';

  /* Never on cart or checkout. */
  var main = document.getElementById('MainContent');
  var template = (main && main.dataset.template) || '';
  if (/cart|checkout/.test(template) || /\/(cart|checkouts?)(\/|$)/.test(location.pathname)) return;

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Per page load only: no cookie, no storage, no visitor id. */
  var pageId = Math.random().toString(36).slice(2, 12);

  /* The only two things written to browser storage are this visitor's own
     preferences: whether they switched the popup off, and how often each product has
     already been announced to them. Neither is an identifier, neither is ever sent
     anywhere, and both are wrapped because storage throws in private mode. */
  function readStore(store, key, fallback) {
    try { return JSON.parse(window[store].getItem(key)) || fallback; }
    catch (e) { return fallback; }
  }
  function writeStore(store, key, value) {
    try { window[store].setItem(key, JSON.stringify(value)); } catch (e) { /* private mode */ }
  }

  if (readStore('localStorage', HIDE_KEY, false)) return;

  var seen = readStore('sessionStorage', SEEN_KEY, {});

  function timesShown(id) { return seen[id] || 0; }
  function noteShown(id) {
    seen[id] = timesShown(id) + 1;
    writeStore('sessionStorage', SEEN_KEY, seen);
  }

  /* Anything carrying its own id is a REVIEW — of a product or of the shop — and is
     keyed by that review and capped at one: the same words from the same customer
     twice reads as a broken loop, where two different people buying the same perfume
     is two real events. Keyed on the FIELD rather than on a list of type names, so
     store reviews needed no second branch here; that is also why this is shorter than
     the version it replaced, which matters at 4908 of 5120 gzipped bytes. */
  function keyOf(e) { return e.id ? 'r' + e.id : String(e.product_id || ''); }
  function capOf(e) { return e.id ? 1 : MAX_PER_PRODUCT; }
  function overExposed(e) { return timesShown(keyOf(e)) >= capOf(e); }

  /* ------------------------------------------------------------------ lock */

  /* One-directional mutex: we respect other popups and publish ours, so a future
     Mykonos widget can read the same lock. */
  var OTHERS = [
    /* MEASURED on mykonosperfumes.eu at 1024x768: the Shopify consent banner is
       #shopify-pc__banner, fixed, z-index 2000000, box x154–871 / y563–768. A toast
       at left:20 / bottom:20 spans x20–420 / y609–748, so it overlaps by ~266px
       horizontally and the banner paints straight over it. This entry is the reason
       the mutex exists. */
    '#shopify-pc__banner',
    /* CWILL (SendWILL/EcomSend) welcome popup — app embed block is ENABLED in
       config/settings_data.json. Same app and same markup as on FragranceGems, where
       the popup was measured holding the screen for 71s. */
    '.react-responsive-modal-root',
    /* Judge.me corner popup, if that block is ever switched on. */
    '.jdgm-popup-widget', '.jdgm-popup',
    /* Horizon puts every one of its own overlays in a native <dialog>: the cart
       drawer (auto_open_cart_drawer is TRUE on this shop, so it opens on every
       add-to-cart), quick add, search, the zoomed gallery and the chat drawer. One
       selector covers all of them and any future one. */
    'dialog[open]'
  ];

  function onScreen(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight;
  }

  var lock = window.__mkPopupLock = window.__mkPopupLock || {
    owner: null,
    busy: function () {
      if (lock.owner) return true;
      for (var i = 0; i < OTHERS.length; i++) {
        if (onScreen(document.querySelector(OTHERS[i]))) return true;
      }
      return false;
    },
    acquire: function (name) {
      if (lock.busy()) return false;
      lock.owner = name;
      return true;
    },
    release: function (name) {
      if (lock.owner === name) lock.owner = null;
    }
  };

  /* --------------------------------------------------------------- styling */

  /* Palette derived from this theme's own config/settings_data.json rather than
     picked by eye:
       settings.color_palette.background  #ffffff   card surface
       settings.color_palette.foreground  #000000   titles, primary text
       settings.color_palette.color1      #333333   secondary text
       settings.color_palette.color2      #DFDFDF   every hairline in this theme
     plus the header top-row scheme, #141D48 navy on #FCEAA1 gold (the same pair the
     cart bubble uses), which is the only accent the shop actually has — so the stars
     are navy, not the FragranceGems gold-on-cream.
     Muted text is foreground at an opacity, which is how Horizon itself derives its
     subdued text, instead of inventing a grey.
     Geometry is the theme's too: EVERY corner radius in settings_data is 0 and every
     border is 1px, so this card is square-cornered with a 1px #DFDFDF edge. The
     theme's uppercase subheading treatment is used in the quick view but NOT on the
     toast's kicker — see the measurement on that rule below. */
  var CSS =
    '.mk-sp{position:fixed;left:16px;bottom:calc(16px + var(--mk-sp-lift,0px) + env(safe-area-inset-bottom,0px));' +
    'z-index:1000000;width:min(340px,calc(100vw - 32px));display:flex;gap:12px;align-items:center;' +
    // A FLOOR, not a fixed height, with align-items:center spreading the slack.
    // The kicker is what varies -- a wrapped "Someone in the Netherlands added to
    // cart" is two lines where a reviewer's name is one -- and that alone moved
    // the FragranceGems card between 99 and 117px. Same layout, same fix.
    'box-sizing:border-box;min-height:118px;' +
    'padding:10px;padding-inline-end:6px;border:1px solid #DFDFDF;background:#fff;' +
    'box-shadow:0 6px 24px rgba(20,29,72,.16);font:400 14px/1.35 inherit;color:#333;text-align:left;' +
    'opacity:0;transform:translateY(12px);transition:opacity .28s ease,transform .28s ease;' +
    'contain:layout paint}' +
    /* pointer-events stay ON during the fade-out too: the card is still visible for
       280ms after the timer fires, and a click landing in that window otherwise
       silently does nothing. */
    '.mk-sp{pointer-events:auto}' +
    '.mk-sp[data-show="1"]{opacity:1;transform:none}' +
    '.mk-sp:not([data-show="1"]){pointer-events:none}' +
    '.mk-sp__img{width:56px;height:56px;flex:0 0 auto;object-fit:cover;background:#F5F5F5}' +
    '.mk-sp__b{min-width:0;flex:1 1 auto}' +
    /* MEASURED at 400px on this storefront: as an uppercase 11px line with .08em
       tracking — the theme's own h5/h6 subheading treatment — "Someone in the
       Netherlands bought" wrapped to TWO lines and made that card 133px against
       117px for a short one, which is exactly the uneven-card problem min-height:2lh
       below exists to prevent. Sentence case on one hard line, ellipsised, fixes it;
       the theme's uppercase flavour stays where it is safe (the quick view). */
    '.mk-sp__k{display:block;font-size:12px;color:rgba(0,0,0,.62);margin-bottom:2px;' +
    'white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    /* Two lines, not one with an ellipsis: these titles carry the concentration
       ("… Extrait de Parfum"), which is exactly the part a single line cuts off.
       min-height:2lh RESERVES the second line even when the title needs one, so
       consecutive cards do not visibly jump size and short ones do not read as thin. */
    '.mk-sp__t{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;' +
    'overflow:hidden;min-height:2lh;font-weight:600;font-size:13px;color:#000}' +
    /* Review variant. Same three slots, different content: the kicker becomes
       "name + stars", the main line becomes the quote and the meta line names the
       perfume. The quote sits in the same slot at the same size and the same two
       lines, so a review card is exactly as tall as a purchase card. */
    /* $= matches BOTH "review" and "store_review" on one selector, so the shop's own
       reviews inherit the quote styling without a second rule and without a byte of
       extra JS. */
    '.mk-sp[data-type$="review"] .mk-sp__t{font-weight:400;color:#333}' +
    /* A store review has no perfume, so the card carries the shop's logo. cover would
       crop a wordmark to a 56px square and cut the ends off the name; contain letters
       it into the same box the bottle shots use, against the theme's #F5F5F5 fill. */
    '.mk-sp[data-type="store_review"] .mk-sp__img{object-fit:contain}' +
    '.mk-sp__s{letter-spacing:1px;font-size:12px;color:#141D48}' +
    /* Same reason: for a review card the meta line is the perfume's name, and
       "Mykonos Dreamscape Extrait de Parfum" wrapped, putting a review at 140px
       against 117px for a purchase. Meta and the opt-out share one flex row, the
       name truncates, the button never moves. MEASURED after the fix: purchase,
       cart-add and review are all exactly 114px whatever the title length. */
    '.mk-sp__m{display:block;min-width:0;white-space:nowrap;overflow:hidden;' +
    'text-overflow:ellipsis;font-size:11.5px;color:rgba(0,0,0,.62)}' +
    /* A visible way out. Muted and small so it never competes with the product, but
       one plain click — no confirm step, no re-prompt.
       position:relative is load-bearing, not cosmetic: .mk-sp__l is an absolutely
       positioned overlay covering the whole card, and a positioned element paints
       above non-positioned siblings regardless of DOM order. Without this the overlay
       swallows every click meant for Hide and for the close ×. */
    '.mk-sp__h{position:relative;z-index:1;flex:0 0 auto;border:0;background:none;padding:0 0 0 8px;' +
    'margin-left:6px;font:inherit;font-size:11.5px;color:rgba(0,0,0,.6);text-decoration:underline;' +
    'cursor:pointer;border-left:1px solid #DFDFDF}' +
    '.mk-sp__h:hover{color:#000}' +
    '.mk-sp__meta-row{display:flex;align-items:baseline;min-width:0;margin-top:2px}' +
    '.mk-sp__x{position:relative;z-index:1;flex:0 0 auto;align-self:flex-start;width:44px;height:44px;' +
    'margin:-6px -2px 0 0;border:0;background:none;color:rgba(0,0,0,.55);font-size:18px;line-height:1;' +
    'cursor:pointer}' +
    '.mk-sp__x:hover{color:#000}' +
    '.mk-sp__l{position:absolute;inset:0}' +
    /* Desktop has the room, and at 340px the card reads as a phone toast stranded on
       a wide screen. Wider card, bigger thumbnail, one step up in type. */
    '@media (min-width: 750px){' +
    '.mk-sp{width:440px;left:20px;bottom:calc(20px + var(--mk-sp-lift,0px));min-height:143px;' +
    'gap:14px;padding:12px;padding-inline-end:8px}' +
    '.mk-sp__img{width:72px;height:72px}' +
    '.mk-sp__k{font-size:13px}' +
    '.mk-sp__t{font-size:15px}' +
    '.mk-sp__m,.mk-sp__h{font-size:13px}' +
    '}' +
    '@media (prefers-reduced-motion: reduce){.mk-sp{transition-duration:.01ms;transform:none}}';

  /* --------------------------------------------------------------- helpers */

  function ago(sec) {
    var m = Math.max(1, Math.round(sec / 60));
    if (m < 60) return m + (m === 1 ? ' minute ago' : ' minutes ago');
    var h = Math.round(m / 60);
    if (h < 24) return h + (h === 1 ? ' hour ago' : ' hours ago');
    var d = Math.round(h / 24);
    return d === 1 ? 'yesterday' : d + ' days ago';
  }

  function track(kind, entry) {
    try {
      var body = JSON.stringify({
        kind: kind,
        entry_type: entry ? entry.type : null,
        product_id: entry ? entry.product_id : null,
        page_id: pageId
      });
      navigator.sendBeacon(API + '/events/track', new Blob([body], { type: 'text/plain' }));
    } catch (e) { /* tracking must never break the page */ }
  }

  /* Conversion attribution. Written ONLY once a cart already exists: doing it for
     every visitor would tag nearly every order and make the comparison meaningless. */
  var attrsWritten = false;

  function cartExists() {
    var b = document.querySelector('.cart-bubble__text-count');
    return !!(b && parseInt(b.textContent, 10) > 0);
  }

  /* FIRST card of the session wins, and it is written exactly once.

     This was page-scoped, and a page is the wrong unit: `attrsWritten` reset on
     every navigation, so browsing home -> product fired a cart mutation per
     pageview and left the attribute describing whichever card opened the LAST
     page. Measured on the FragranceGems store 20 sep 2026. sessionStorage also
     fixes the case where the popup is seen BEFORE a cart exists -- the old
     pendingAttrs died with the page, so that wrote nothing at all. */
  function writeAttrs(attrs) {
    if (attrsWritten) return;
    var saved = readStore('sessionStorage', ATTR_KEY, null);
    if (saved === 1) { attrsWritten = true; return; }
    if (!saved) saved = attrs;
    if (!saved) return;
    writeStore('sessionStorage', ATTR_KEY, saved);
    if (!cartExists()) return;
    attrsWritten = true;
    writeStore('sessionStorage', ATTR_KEY, 1);
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: saved }),
      keepalive: true
    }).catch(function () {
      attrsWritten = false;
      writeStore('sessionStorage', ATTR_KEY, saved);
    });
  }

  window.__mkSalespopFlush = function () {
    writeAttrs(null); // the stored first card is picked up inside
  };

  /* The quick-view asset reports its own add-to-carts through here, so a conversion
     from a popup click is measurable without that file knowing the endpoint. */
  window.__mkSalespopTrack = track;

  /* ------------------------------------------------------------------ view */

  var el = null, hideTimer = null, current = null, stopped = false, dismissals = 0;

  function build() {
    var s = document.createElement('style');
    s.textContent = CSS;
    document.head.appendChild(s);

    el = document.createElement('aside');
    el.className = 'mk-sp';
    /* Deliberately OUT of the accessibility tree. As role="status" + aria-live it
       made a screen reader announce a sales notification every 12–30 seconds — an
       interruption, not information. Everything here is reachable by normal
       browsing, so nothing is lost by making the card visual-only. */
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<a class="mk-sp__l" href="#" aria-hidden="true" tabindex="-1"></a>' +
      '<img class="mk-sp__img" alt="" width="56" height="56" loading="lazy" decoding="async">' +
      '<div class="mk-sp__b">' +
      '<span class="mk-sp__k"></span><span class="mk-sp__t"></span>' +
      '<span class="mk-sp__meta-row"><span class="mk-sp__m"></span>' +
      '<button class="mk-sp__h" type="button" hidden>Hide these</button></span></div>' +
      '<button class="mk-sp__x" type="button" aria-label="Close">×</button>';
    el.style.position = 'fixed';
    document.body.appendChild(el);

    /* Reaching for a card that disappears after five seconds is the likeliest way a
       click "does nothing". Hovering holds it open; leaving restarts the clock.
       Touch devices have no hover, so they are unaffected. */
    el.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    el.addEventListener('mouseleave', function () {
      if (el.dataset.show === '1') hideTimer = setTimeout(hide, 1200);
    });

    el.querySelector('.mk-sp__x').addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      track('dismiss', current);
      dismissals++;
      hide();
    });
    el.querySelector('.mk-sp__h').addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      track('hide', current);
      writeStore('localStorage', HIDE_KEY, true);
      hide();
      if (el.parentNode) el.parentNode.removeChild(el);
      stopped = true;
    });
    el.querySelector('.mk-sp__l').addEventListener('click', function (ev) {
      /* NOT `|| !current.handle` any more: a store review has no handle, and that
         guard made a store-review card a click that silently did nothing. */
      if (!current) return;
      ev.preventDefault();
      track('click', current);
      var e = current;
      hide();
      openOverlay(e);
    });
  }

  var qvLoading = false;

  /* Everything opens in place rather than navigating: a store review opens the shop
     panel, a product review opens that review, a bought / added-to-cart card opens the
     product. Both review flavours are addressed by their own id — the store panel
     needs it too, so it can show the quote that earned the click ABOVE the shop's
     numbers instead of replacing it with them. */
  function openOverlay(e) {
    var fn = e.type === 'store_review' ? '__mkStoreView'
      : e.body ? '__mkReviewView' : '__mkQuickView';
    var arg = e.body ? e.id : e.handle;
    var fallback = function () {
      location.href = root + (e.handle ? 'products/' + e.handle : 'pages/our-story');
    };
    if (!arg) return fallback();
    if (window[fn]) return window[fn](arg);
    if (qvLoading || !QV_SRC) return fallback();
    qvLoading = true;
    var sc = document.createElement('script');
    sc.src = QV_SRC;
    sc.onload = function () {
      qvLoading = false;
      if (window[fn]) window[fn](arg); else fallback();
    };
    // Never leave a click doing nothing: if the asset fails, just navigate.
    sc.onerror = function () { qvLoading = false; fallback(); };
    document.head.appendChild(sc);
  }

  /* MEASURED on this storefront: .sticky-add-to-cart__bar is 74px tall, centred
     (x212–812 at 1024px wide) and sits at the bottom edge once scrolled into view,
     so it overlaps the toast horizontally from x212. Measure rather than hard-code,
     so a future bottom bar is handled too. */
  function lift() {
    var most = 0;
    var bars = document.querySelectorAll('.sticky-add-to-cart__bar');
    for (var i = 0; i < bars.length; i++) {
      var b = bars[i];
      if (!onScreen(b)) continue;
      var r = b.getBoundingClientRect();
      if (r.bottom >= innerHeight - 4) most = Math.max(most, r.height + 8);
    }
    el.style.setProperty('--mk-sp-lift', most + 'px');
  }

  var VERB = { purchase: ' bought', cart_add: ' added to cart' };

  /* One component, four sub-templates — only the three text slots and the image
     change. Purchase/cart-add: "Someone in X bought" / product / how long ago.
     Product review: "Name ★★★★★" / the quote / which perfume. Store review: the same
     three slots, with the shop's logo and the Worker's localised label ("Winkelreview
     FragranceGems", "Shop-Bewertung FragranceGems · Verifizierter Kunde") where the
     perfume name goes.
     The branch is on whether the entry HAS a quote, not on a list of type names, so
     the fourth card type needed no fourth branch. */
  function render(e, now) {
    el.dataset.type = e.type;
    var img = el.querySelector('.mk-sp__img');
    /* A store review carries the SHOP's wordmark, never the customer's photo, even
       when Judge.me has one: this is the shop's card, and object-fit:contain above is
       sized for a wordmark — it would letterbox a portrait snapshot between two grey
       bars. The photo still leads the panel behind the click, which is where it has
       the room to be looked at. A product review keeps using its photo when it has
       one; that has always been the better thumbnail than a repeat of the bottle. */
    img.src = (e.type === 'store_review' ? '' : e.photo) || e.image;
    img.alt = e.title;
    var k = el.querySelector('.mk-sp__k');

    if (e.body) {
      k.textContent = e.reviewer ? e.reviewer + ' ' : '';
      var stars = document.createElement('span');
      stars.className = 'mk-sp__s';
      stars.textContent = '★'.repeat(e.rating || 5);
      k.appendChild(stars);
      el.querySelector('.mk-sp__t').textContent = '“' + e.body + '”';
      el.querySelector('.mk-sp__m').textContent = e.title;
    } else {
      k.textContent = (e.flag ? e.flag + ' ' : '') +
        (e.country ? 'Someone in ' + e.country : 'Someone') + VERB[e.type];
      el.querySelector('.mk-sp__t').textContent = e.title;
      /* This shop has almost no order history of its own, so most purchase and
         cart-add cards are real FragranceGems events for Mykonos perfumes. Saying so
         is a legitimacy point, not decoration: without it the card implies the order
         was placed here. It goes on the META line and not in the kicker because the
         kicker is the line that WRAPS, and the 118/143px min-height floor above was
         measured off its worst case — the meta line is already one hard line with an
         ellipsis, so it degrades instead of growing the card.
         Guarded, not assumed: a native Mykonos order arrives with no `via` at all,
         and today every purchase carries one only because this shop has no orders
         of its own yet. */
      el.querySelector('.mk-sp__m').textContent = ago(Math.max(0, now - e.ts)) +
        (e.via ? ' · via ' + e.via : '');
    }
    /* A store review has no perfume behind it, so the href falls back to the page
       that answers the same question the panel does. Never '#': the overlay is a real
       link and a middle-click or a failed asset load has to land somewhere real. */
    el.querySelector('.mk-sp__l').href =
      root + (e.handle ? 'products/' + e.handle : 'pages/our-story');
  }

  function show(e, now) {
    if (!lock.acquire('salespop')) return false;
    current = e;
    render(e, now);
    lift();
    el.querySelector('.mk-sp__h').hidden = dismissals < HIDE_AFTER_DISMISSALS;
    el.dataset.show = '1';
    noteShown(keyOf(e));
    track('impression', e);
    writeAttrs({
      _salespop_seen: '1',
      _salespop_type: e.type,
      _salespop_product: String(e.product_id || '')
    });
    hideTimer = setTimeout(hide, VISIBLE_MS + (reduced ? 0 : 280));
    return true;
  }

  function hide() {
    clearTimeout(hideTimer);
    el.dataset.show = '0';
    current = null;
    lock.release('salespop');
  }

  /* ------------------------------------------------------------- cart-adds */

  /* NOT a fetch/XHR patch. Click/submit listener, then poll /cart.js and report only
     the line that really appeared. May under-count, can never invent an add, and adds
     no request at all on a page where nobody clicks add-to-cart.
     Only the product ID is sent: the Worker looks the title up in the shop's own
     primary locale (en), because /cart.js hands back whatever language that shopper
     was browsing — this shop publishes en, nl and de, so that trap is live here. */
  var ADDERS = '[name="add"],.add-to-cart-button,.quick-add__button';
  var polling = false;

  function readCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function lineKey(i) { return i.key || i.variant_id || i.id; }

  function qtyMap(c) {
    var m = {};
    if (c && c.items) for (var i = 0; i < c.items.length; i++) m[lineKey(c.items[i])] = c.items[i].quantity;
    return m;
  }

  function beaconAdds(before, after) {
    var sent = 0;
    for (var i = 0; i < after.items.length; i++) {
      var it = after.items[i];
      if ((before[lineKey(it)] || 0) >= it.quantity) continue;
      try {
        navigator.sendBeacon(API + '/events/cart-add', new Blob([JSON.stringify({
          product_id: String(it.product_id || '')
        })], { type: 'text/plain' }));
        sent++;
      } catch (err) { /* a beacon must never break add-to-cart */ }
    }
    return sent;
  }

  function watchCart() {
    if (polling) return;
    polling = true;
    readCart().then(function (before) {
      if (!before) { polling = false; return; }
      var was = qtyMap(before), tries = 0;
      (function again() {
        setTimeout(function () {
          readCart().then(function (after) {
            if (after && after.items && beaconAdds(was, after)) {
              polling = false;
              window.__mkSalespopFlush(); // a cart exists now; flush any pending attrs
              return;
            }
            if (++tries < 8) again(); else polling = false;
          });
        }, 350);
      })();
    });
  }

  addEventListener('click', function (ev) {
    var t = ev.target;
    if (t && t.closest && t.closest(ADDERS)) watchCart();
  }, true);
  addEventListener('submit', function (ev) {
    var f = ev.target;
    if (f && f.action && f.action.indexOf('/cart/add') > -1) watchCart();
  }, true);

  /* ------------------------------------------------------------------ loop */

  var queue = [], drift = 0;

  function fetchFeed() {
    /* 20, not 12: the per-product cap below filters this list, and a short feed can
       filter down to almost nothing and force a refetch every round.
       Reviews are shown in the shopper's own language where we have them: nl on
       officialmykonos.nl, de on .de and .at, English on mykonosperfumes.eu and
       everywhere else. Read from the page's own lang attribute rather than the
       domain, so a locale served under a shared domain still gets the right pool. */
    var u = API + '/popup/feed?limit=20&lang=' +
      ((document.documentElement.lang || 'en').slice(0, 2).toLowerCase());
    var pid = productIdOnPage();
    if (pid) u += '&product_id=' + pid;
    return fetch(u, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        queue = (d.entries || []).filter(function (e) { return !overExposed(e); });
        drift = d.now - Math.floor(Date.now() / 1000);
      })
      .catch(function () { queue = []; });
  }

  /* The buy form is authoritative: Horizon gives every product CARD a
     [data-product-id] too, so a loose query returns a recommendation instead. */
  function productIdOnPage() {
    var i = document.querySelector('#MainContent input[name="product-id"], #MainContent input[name="product_id"]');
    if (i && /^\d+$/.test(i.value)) return i.value;
    var m = document.querySelector('.shopify-section[id$="__main"] [data-product-id]:not(product-card-link)');
    if (m && /^\d+$/.test(m.dataset.productId)) return m.dataset.productId;
    return null;
  }

  function gap(first) {
    var table = first ? FIRST_GAP : GAP;
    var g = PHONE.matches ? table.phone : table.desktop;
    return g[0] + Math.random() * (g[1] - g[0]);
  }

  function tick() {
    if (stopped) return;
    if (document.hidden) return setTimeout(tick, RECHECK_MS);
    // Drop anything this visitor has already been shown its cap of times.
    while (queue.length && overExposed(queue[0])) queue.shift();
    if (!queue.length) {
      return fetchFeed().then(function () {
        setTimeout(tick, queue.length ? gap() : 5 * 60000);
      });
    }
    var e = queue.shift();
    var ok = show(e, Math.floor(Date.now() / 1000) + drift);
    if (!ok) {
      // Another popup owns the screen: put it back, retry. Never stack.
      queue.unshift(e);
      return setTimeout(tick, RECHECK_MS);
    }
    setTimeout(tick, gap());
  }

  function start() {
    if (el) return;
    build();
    fetchFeed().then(function () {
      if (queue.length) setTimeout(tick, gap(true));
    });
  }

  function arm() {
    ['scroll', 'touchstart', 'mousemove', 'keydown'].forEach(function (t) {
      addEventListener(t, once, { passive: true, once: true });
    });
    if (document.readyState === 'complete') setTimeout(start, 0);
    else addEventListener('load', once, { once: true });
  }
  function once() { start(); }

  arm();
})();
